import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { ArrowRight } from "lucide-react";

const CTABanner = () => {
  const { t } = useLanguage();
  const scroll = (e) => {
    e.preventDefault();
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="cta-banner"
      className="py-12 sm:py-20 px-5 sm:px-8 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] bg-gradient-to-br from-brand-surface to-white border border-brand-line/70 p-8 sm:p-14 lg:p-16 grain">
          <div className="absolute top-0 right-0 w-80 h-80 bg-brand/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" />

          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-8">
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-brand-ink leading-tight mb-4">
                {t.ctaBanner.title}
              </h2>
              <p className="text-base sm:text-lg text-brand-muted max-w-xl">
                {t.ctaBanner.subtitle}
              </p>
            </div>
            <div className="md:col-span-4 flex md:justify-end">
              <a
                href="#contact"
                onClick={scroll}
                data-testid="cta-banner-btn"
                className="inline-flex items-center gap-2 rounded-full bg-brand text-white px-7 py-4 text-base font-semibold shadow-lg hover:bg-brand-hover hover:-translate-y-1 transition-all duration-300 shine-hover"
              >
                {t.ctaBanner.cta}
                <ArrowRight size={18} strokeWidth={2} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
